export default "__VITE_ASSET__de04572b__"